module.exports = __webpack_public_path__ + "img/Ordermde4_6_chousei_2.6b228ad4.png";